import { FC, useState } from "react";
import EnterEmail from "./components/EnterEmail";
import VerifyEmail from "./components/VerifyEmail";
import ChangePassword from "./components/ChangePassword";

interface IForgotPasswordProps {}

const ForgotPassword: FC<IForgotPasswordProps> = ({}) => {
  const [forgotPasswordStep, setForgotPasswordStep] = useState(0);
  const [otpCode, setOtpCode] = useState("");

  return (
    <>
      {forgotPasswordStep === 0 && <EnterEmail setForgotPassword={setForgotPasswordStep} />}
      {forgotPasswordStep === 1 && (
        <VerifyEmail setForgotPasswordStep={setForgotPasswordStep} setOtpCode={setOtpCode} />
      )}
      {forgotPasswordStep === 2 && (
        <ChangePassword setForgotPasswordStep={setForgotPasswordStep} otpCode={otpCode} />
      )}
    </>
  );
};

export default ForgotPassword;
